export const CREATE_SUBFOLDER_FIELDS = {
  NAME: "name",
} as const;
